module.exports = __webpack_public_path__ + "img/szgl.08e41c43.png";